import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRewardPriceBookInfo = createAsyncThunk("fetchRewardPriceBookInfo", async (id) => {
	const response = await axiosHttp.get(`pricebook/${id}`);
	return response.data.data;
});

const RewardPriceBookInfoSlice = createSlice({
	name: "RewardPriceBookInfoSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardPriceBookInfo.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchRewardPriceBookInfo.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchRewardPriceBookInfo.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default RewardPriceBookInfoSlice.reducer;
